import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex';
import { ISession } from '../../../types';
import { validUserName } from '../../../helper-functions/validators'
import textInput from '../../../components/text-input/text-input.vue'

@Component({
  components: {
    textInput,
  },
  computed: mapState({

    Moderator: (state: {session: ISession}) => state.session.roles != undefined ? true : false
  })
})

export default class Login extends Vue {

  private namespace: string = '/Account';
  
  private username: string = '';

  private password: string = '';

  private alertMessage: string = '';

  private Moderator!: boolean;

  private error: boolean = false;

  private authenticated: boolean = false;

  private disabled: boolean = false;

  private get enabled () {
    
    return validUserName(this.username)
      && this.password != null
        && this.password !== ''
          && !this.disabled;
  }

  private alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async authenticate () {

    this.authenticated = true;

    try {
      
      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/Login`, {
        username: this.username,
        password: this.password
      });
      
      this.authenticated = false;
      this.$store.commit('createSession', response.data);

    } catch (err) {

      if (err.response != null) {

        let status = err.response.status;

        switch(status) {
          case 403:
              status = this.$t('errors.lockedout') as string;
            break;
          case status >= 500:
            status = this.$t('errors.general') as string;
            break;
          default: 
            status = this.$t('errors.loginFailure') as string;
        }

        this.alertMessage = status;
      }

      this.alertMessage = this.$t('errors.general') as string;
      
      this.authenticated = false;
      this.error = !this.error;
      this.alertReset();
      
    } finally {

      const pathReplace = this.Moderator
        ? 'console'
        : 'overview';
      
      this.$router.replace({name: pathReplace});
    }
  }
}